<template>
    <section class="compliance-requirements-section">
        <div v-if="showHeading" class="compliance-requirements-section__heading">
            <h5 class="mb-0">
                {{ translate(
                    'Page(ReceivedRequest):Component(ComplianceInformation):information-required',
                    'Information required',
                ) }}
            </h5>
            <b-badge variant="light-secondary">
                {{ count }}
                {{ translate('Component(Text):items', 'items') }}
            </b-badge>
        </div>

        <slot />

        <div v-if="loaded && count === 0" class="text-muted py-2">
            {{ translate(
                'Page(ReceivedRequest):Component(ComplianceInformation):no-list-requirements',
                'No substance-list requirements were requested.',
            ) }}
        </div>
    </section>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    name: 'ComplianceRequirementsSection',
    components: { BBadge },
    props: {
        count: { type: Number, required: true },
        loaded: { type: Boolean, default: false },
        showHeading: { type: Boolean, default: false },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)
            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>

<style lang="scss" scoped>
.compliance-requirements-section {
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
    padding: 0 1.25rem;

    &__heading {
        align-items: center;
        border-bottom: 1px solid #ebe9f1;
        display: flex;
        gap: .75rem;
        margin: 0 -1.25rem;
        padding: 1rem 1.25rem;
    }
}
</style>
